import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuthStore } from '../stores/auth.store'
import styles from './Login.module.scss'

export function Login() {
  const navigate = useNavigate()
  const { user, hasAccess, isLoading, signInWithGoogle } = useAuthStore()

  useEffect(() => {
    if (user && hasAccess) {
      navigate('/')
    }
  }, [user, hasAccess, navigate])

  const handleGoogleSignIn = async () => {
    const { error } = await signInWithGoogle()
    if (error) {
      console.error('Sign in error:', error)
    }
  }

  if (user && hasAccess && !isLoading) {
    return (
      <div className={styles.redirectContainer}>
        <div className={styles.redirectCard}>
          <div className={styles.redirectContent}>
            <div className={styles.checkIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 6L9 17L4 12" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>You're already signed in!</h2>
            <p>Redirecting you to QR Maker...</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.loginBox}>
        <div className={styles.leftPanel}>
          <div className={styles.logo}>
            <img src="/egos-logo-full.svg" alt="Excel Group of Schools" />
          </div>
          <div className={styles.content}>
            <h1>QR Maker</h1>
            <p>Sign in to continue</p>

            <button 
              className={styles.googleButton} 
              onClick={handleGoogleSignIn}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 size={20} className={styles.spinner} />
                  Signing in...
                </>
              ) : (
                <>
                  <img src="https://www.google.com/favicon.ico" alt="Google" />
                  Sign in with Google
                </>
              )}
            </button>

            <div className={styles.footer}>
              <p>Use your @excelschools.edu.in account</p>
            </div>
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div className={styles.rightPanelImage} />
        </div>
      </div>
    </div>
  )
}
